import axios from 'axios';

import validateOpportunity from '@/BuyNow/store/actions/validate-opportunity.js';
import validateJwt from '@/BuyNow/store/actions/validate-jwt.js';
import submitPurchase from '@/BuyNow/store/actions/submit-purchase.js';
import submitContactSales from '@/BuyNow/store/actions/submit-contact-sales.js';
import submitFeedback from '@/BuyNow/store/actions/submit-feedback.js';
import setTracking from '@/BuyNow/store/actions/set-tracking.js';
import loadStateFromQuery from '@/BuyNow/store/actions/load-state-from-query.js';
import loadStateFromDB from '@/BuyNow/store/actions/load-state-from-db.js';
import loadStateFromCookie from '@/BuyNow/store/actions/load-state-from-cookies.js';
import fetchPricing from '@/BuyNow/store/actions/fetch-pricing.js';
import fetchEstimate from '@/BuyNow/store/actions/fetch-estimate.js';
import fetchSubscription from '@/BuyNow/store/actions/fetch-subscription.js';
import fetchCustomer from '@/BuyNow/store/actions/fetch-customer.js';
import fetchBundleDetails from '@/BuyNow/store/actions/fetch-bundle-details.js';
import hydrate from '@/BuyNow/store/actions/hydrate.js';

export default {
    async validateOpportunity({ commit, getters }) {
        await validateOpportunity(commit, getters);
    },
    async validateJwt({ commit, getters }) {
        await validateJwt(commit, getters);
    },
    async submitPurchase({ commit, getters }) {
        await submitPurchase(commit, getters);
    },
    async submitReconsideration({ commit, state, getters }, payload) {
        let { data } = await axios.post('/api/v1/message/reconsideration', {
            ...payload,
            ...(!!getters.purchaseInfo.partnerAccountId && {partnerAccountId: getters.purchaseInfo.partnerAccountId}),
            app: 'BuyNow',
        });
        return data;
    },
    async submitFeedback({ commit, getters }, feedback) {
        return await submitFeedback(commit, getters, feedback);
    },
    async submitContactSales({ commit, getters }) {
        await submitContactSales(commit, getters);
    },
    async loadStateFromQuery({ commit }, query) {
        await loadStateFromQuery(commit, query);
    },
    async loadStateFromDB({ commit }, query) {
        await loadStateFromDB(commit, query);
    },
    async loadStateFromCookie({ commit, getters, state}) {
        await loadStateFromCookie(commit, getters, state);
    },
    async fetchPricing({ commit, getters }) {
        await fetchPricing(commit, getters);
    },
    async fetchEstimate({ commit, getters }) {
        await fetchEstimate(commit, getters);
    },
    async fetchSubscription({ commit, getters }) {
        await fetchSubscription(commit, getters);
    },
    async fetchCustomer({ commit, getters }) {
        await fetchCustomer(commit, getters);
    },
    async fetchBundleDetails({ commit, getters }) {
        await fetchBundleDetails(commit, getters);
    },
    async hydrate({ state, commit, getters }) {
        await hydrate(state, commit, getters);
    },
    async setTracking({ commit, getters }, query) {
        await setTracking(commit, query);
    },
    async getFeatureFlags({ commit }) {
        let { data } = await axios.get(`/api/v1/system/feature-flags`);
        return commit('setFeatureFlags', data);
    },
};
